<template>

    <div id="demo-basic-card">
        <div v-if="documentos.length === 0">
          <vx-card>
            <vs-alert color="danger" icon-pack="feather" icon="icon-info">
              <span>No existe ningún anuncio actualmente.</span>
            </vs-alert>           
          </vx-card>
        </div>
        <div v-for="(anuncios, index) in anunciosAgrupados" :key="index" class="vx-row">           
            <div v-for="(anuncio, index) in anuncios" :key="index" class="vx-col sm:w-1/2 lg:w-1/2 mb-base">                               
                <div slot="no-body">
                  <img :src="`${baseUrl}/documentos/anuncios/${anuncio.id}___${anuncio.fichero}`" :alt="`${anuncio.fichero}`" class="responsive card-img-top">                  
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import anunciosStore from '@/store/configuracion/anuncios/index.js'

export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      documentos: []
    }
  },
  computed:{
    anunciosAgrupados () {
      const result = []
      const arr = JSON.parse(JSON.stringify(this.$store.state.anunciosStore.anuncios))
      for (let i = 0; i < this.documentos.length; i += 2) {
        result.push(arr.slice(i, i + 2))
      }
      return result              
    }
  },
  async created () {
    if (!anunciosStore.isRegistered) {
      this.$store.registerModule('anunciosStore', anunciosStore)
      anunciosStore.isRegistered = true
    }

    await this.$store.dispatch('anunciosStore/getDocumentos')
    this.anuncios = JSON.parse(JSON.stringify(this.$store.state.anunciosStore.anuncios))
    this.anuncios.length > 0 ? this.documentos = this.anuncios : this.documentos = []        
  }
}
</script>